import { createSlice } from "@reduxjs/toolkit";

/**
 * Slice minimo de UI. Sirve para tener un reducer valido en el store base
 * y como punto de partida para el estado transversal (p.ej. filtros de cohorte).
 *
 * `pharmaSubgroupFilter`: subgrupo seleccionado en el modulo Subgroups de
 * farma (id de src/data/pharma/subgroups.json o "all"). Vive en Redux (no
 * useState local) porque debe persistir al navegar entre las 4 subvistas
 * de Subgroups (Overview/Characterization/QoL/Adherence).
 */
const uiSlice = createSlice({
    name: "ui",
    initialState: {
        pharmaSubgroupFilter: "all",
    },
    reducers: {
        setPharmaSubgroupFilter(state, action) {
            state.pharmaSubgroupFilter = action.payload;
        },
    },
});

export const { setPharmaSubgroupFilter } = uiSlice.actions;
export const selectPharmaSubgroupFilter = (state) => state.ui.pharmaSubgroupFilter;
export default uiSlice.reducer;
